import Sidebar from './SideBar.vue';
import SidebarItem from './SidebarItem.vue';

const SIDEBAR_MINIMIZED_KEY = 'sidebar-minimized';

function getStoredSidebarState() {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    return localStorage.getItem(SIDEBAR_MINIMIZED_KEY) === 'true';
  } catch (error) {
    return false;
  }
}

function syncBodySidebarClass(isMinimized) {
  if (typeof document === 'undefined') {
    return;
  }

  document.body.classList.toggle('sidebar-mini', isMinimized);
}

const SidebarStore = {
  showSidebar: false,
  sidebarLinks: [],
  isMinimized: getStoredSidebarState(),
  displaySidebar(value) {
    this.showSidebar = value;
  },
  toggleMinimize() {
    this.isMinimized = !this.isMinimized;
    syncBodySidebarClass(this.isMinimized);

    try {
      localStorage.setItem(SIDEBAR_MINIMIZED_KEY, this.isMinimized);
    } catch (error) {
      // Ignore storage failures and keep the in-memory state.
    }

    // we simulate the window Resize so the charts will get updated in realtime.
    const simulateWindowResize = setInterval(() => {
      window.dispatchEvent(new Event('resize'));
    }, 180);

    // we stop the simulation of Window Resize after the animations are completed
    setTimeout(() => {
      clearInterval(simulateWindowResize);
    }, 1000);
  }
};

syncBodySidebarClass(SidebarStore.isMinimized);

const SidebarPlugin = {
  install(Vue, options) {
    if (options && options.sidebarLinks) {
      SidebarStore.sidebarLinks = options.sidebarLinks;
    }
    let app = new Vue({
      data: {
        sidebarStore: SidebarStore
      }
    });
    Vue.prototype.$sidebar = app.sidebarStore;
    Vue.component('side-bar', Sidebar);
    Vue.component('sidebar-item', SidebarItem);
  }
};

export default SidebarPlugin;
